module.exports = __webpack_public_path__ + "img/web-pigai.ad5a19e2.png";